module.exports = __webpack_public_path__ + "static/media/metrics_decrease.8201d43a.svg";